const routes = [
    {
        path: "/instructor/exam/requests/admin",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true ,
            permission:'instructorexamrequest_index'
        }
    }
];

export default routes;
